// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605250803/js/" + chunkId + "." + {"44":"58f9c0a7","225":"907005fb","481":"a441e589","486":"f62dc222","770":"c3173eb7"}[chunkId] + ".0.6929739664526555.chunk.js";
};